/* eslint-disable no-restricted-syntax */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectRouterState } from '@mona/store';
import { NotificationsState } from '../../entities';
import { notificationsFeatureKey, notificationsAdapter } from '../reducers/notifications.reducer';

export const selectNotificationsState = createFeatureSelector<NotificationsState>(notificationsFeatureKey);

/**
 * Get Unread notification count
 */
export const selectUnreadNotificationsCount = createSelector(
    selectNotificationsState,
    (state: NotificationsState) => state.unreadCount,
);

/**
 * Get unread count from state
 */
export const selectUnreadCount = createSelector(
    selectNotificationsState,
    (state: NotificationsState) => state.unreadCount || 0,
);

/**
 * Get Unread paginated notification count
 */
export const selectUnreadPaginatedNotificationsCount = createSelector(
    selectNotificationsState,
    (state: NotificationsState) =>
        notificationsAdapter
            .getSelectors()
            .selectAll(state.allNotifications)
            .filter(notification => !notification.readStatus).length,
);

/**
 * Get paginated notifications
 */
export const selectAllNotifications = createSelector(selectNotificationsState, (state: NotificationsState) =>
    notificationsAdapter.getSelectors().selectAll(state.allNotifications),
);

/**
 * Get unread notifications
 */
export const selectUnreadNotifications = createSelector(selectNotificationsState, (state: NotificationsState) =>
    notificationsAdapter.getSelectors().selectAll(state.unreadNotifications),
);

/**
 * Get paginated notifications state
 */
export const selectPaginatedNotificationsState = createSelector(
    selectNotificationsState,
    (state: NotificationsState) => state,
);

/**
 * Get next URL for pagination
 */
export const selectNextUrlAll = createSelector(
    selectNotificationsState,
    (state: NotificationsState) => state.nextUrlAll,
);

/**
 * Get next URL for unread notifications pagination
 */
export const selectNextUrlUnread = createSelector(
    selectNotificationsState,
    (state: NotificationsState) => state.nextUrlUnread,
);

/**
 * Get whether currently loading more notifications
 */
export const selectIsLoadingMoreNotifications = createSelector(
    selectNotificationsState,
    (state: NotificationsState) => state.isLoading,
);

/**
 * Get has unread notifications
 */
export const selectHasUnreadNotifications = createSelector(
    selectNotificationsState,
    (state: NotificationsState) => state.hasUnreadNotifications,
);

/**
 * Get notifications of encounter
 *
 * @param encounterId EntityId<Encounter>
 */
export const selectEncounterNotifications = createSelector(
    selectRouterState,
    selectAllNotifications,
    (routerState, notifications) => {
        const encounterId = routerState.params?.encounterId;
        if (routerState.url.includes('encounter') && encounterId) {
            return notifications.filter(notification => notification.encounterId === encounterId);
        }
        return null;
    },
);

export const selectEncounterNotificationsCount = createSelector(
    selectRouterState,
    selectUnreadNotificationsCount,
    (routerState, unreadCount) => {
        const encounterId = routerState.params?.encounterId;
        if (routerState.url.includes('encounter') && encounterId) {
            return unreadCount;
        }
        return null;
    },
);
